import React, { useContext, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link as RouterLink, useParams } from 'react-router-dom';
import parse, { domToReact } from 'html-react-parser';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { connect, useDispatch } from 'react-redux';
import LanguageContext from '../utils/LanguageContext';

import FocusableHeader from '../focusableHeader.jsx';
import BasicHeader from '../BasicHeader.jsx';

import * as Scroll from 'react-scroll';
let ScrElement = Scroll.Element;
let scroll = Scroll.animateScroll;
var scroller = Scroll.scroller;
let ScrLink = Scroll.Link;

const useStyles = makeStyles((theme) => ({
    paddedPaper: {
        padding: theme.spacing(1),
    },

    search: {
        position: 'relative',
        //border: 'thin solid gray',

        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {},
    },
    searchIcon: {
        width: theme.spacing(7),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 7),

        width: '100%',

        fontSize: '1.5rem',
    },
    resultsPaper: {
        padding: theme.spacing(5, 5, 4),
    },
    resultItemGroupPaper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(4),
    },
    resultItemPaper: {
        cursor: 'pointer',
        padding: theme.spacing(2),
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    link: {
        'color': theme.palette.secondary.main,
        'textDecoration': 'none',
        '&:hover': {
            color: theme.palette.secondary.dark,
        },

        'cursor': 'pointer',
    },
    headerLink: {
        'color': theme.palette.secondary.main,
        'textDecoration': 'none',
        '&:hover': {
            color: theme.palette.secondary.dark,
        },

        'cursor': 'pointer',
    },

    searchResultLabel: {
        //paddingBottom: theme.spacing(6),
        marginBottom: theme.spacing(4),
        marginLeft: theme.spacing(1),
    },
    item_type_label: {
        'color': 'rgba(0, 0, 0, 0.54)',
        'fontSize': '0.875rem',
        'fontWeight': 500,
        'paddingBottom': theme.spacing(2),
        'marginBottom': theme.spacing(3),
        '& svg': {
            position: 'relative',
            top: '6px',
            marginRight: '8px',
        },
    },
}));
const Link = (props) => {
    const classes = useStyles();
    const isLocal = props.href.startsWith('/');
    if (isLocal) {
        return (
            <RouterLink to={props.href} className={classes.link}>
                {domToReact(props.children, options)}
            </RouterLink>
        );
    } else {
        return (
            <a href={props.href} className={classes.link} target="_blank">
                {domToReact(props.children, options)}
            </a>
        );
    }
};

const AlignRight = (props) => {
    return (
        <p style={{ textAlign: 'right' }}>
            {domToReact(props.children, options)}
        </p>
    );
};

const lookups = {
    'link': Link,
    'align-right': AlignRight,
};

const options = {
    replace: (domNode) => {
        if (domNode.name && domNode.name.startsWith('react:')) {
            const attribs = Object.fromEntries(
                Object.entries(domNode.attribs).map(([k, v]) => {
                    return [k.replace('data-', ''), v];
                }),
            );
            const elem_name = domNode.name.split(':')[1];
            return React.createElement(
                lookups[elem_name],
                attribs,
                domNode.children,
            );
        }
    },
};

const About = (props) => {
    const { _ } = useContext(LanguageContext);
    const classes = useStyles();
    useEffect(() => {
        if (props.hash && props.hash !== '') {
            scroller.scrollTo('guide', { offset: -100 });
        }
    }, []);
    return (
        <>
            <Helmet>
                <title>Eric Hobsbawm Bibliography | About</title>
            </Helmet>

            <Grid container direction="row" justifyContent="center">
                <Grid item xs={7}>
                    <Box mt={2}>
                        <Typography variant="h4" component="div">
                            <FocusableHeader className="leader" autoFocus>{_('about_h1')}</FocusableHeader>
                        </Typography>
                        <Box mt={2}>
                            <Typography variant="body2" component="div">
                                See also:{' '}
                                <ScrLink
                                    to="guide"
                                    className={classes.headerLink}
                                    smooth={true}
                                    offset={-100}
                                >
                                    {_('guide_h1')}
                                </ScrLink>{' '}
                                |{' '}
                                <ScrLink
                                    to="encoding"
                                    className={classes.headerLink}
                                    smooth={true}
                                    offset={-100}
                                >
                                    Data encoding
                                </ScrLink>
                            </Typography>
                        </Box>
                        <Box mt={2}>
                            <Typography variant="body1" component="div">
                                {parse(_('about_text'), options)}
                            </Typography>
                        </Box>
                    </Box>
                    <ScrElement name="guide">
                        <Box mt={2}>
                            {/*
                            <Typography variant="h1" component="h4" className="focusableHeader leader">
                                {_('guide_h1')}
                            </Typography>
                            */}
                            <BasicHeader>
                                {_('guide_h1')}
                            </BasicHeader>
                            <Box mt={2}>
                                <Typography component="div">
                                    {parse(_('guide_text'), options)}
                                </Typography>
                            </Box>
                        </Box>
                    </ScrElement>
                    <ScrElement name="encoding">
                        <Box mt={2}>
                            {/*
                            <Typography component="h4" className="focusableHeader leader">
                                {_('data_encoding_h1')}
                            </Typography>
                            */}
                            <BasicHeader>
                                {_('data_encoding_h1')}
                            </BasicHeader>
                            <Box mt={2}>
                                <Typography variant="body1" component="div">
                                    {parse(_('data_encoding_text'), options)}
                                </Typography>
                            </Box>
                        </Box>
                    </ScrElement>
                </Grid>
            </Grid>
        </>
    );
};

const mapStateToProps = (state) => ({
    pathname: state.router.location.pathname,
    search: state.router.location.search,
    hash: state.router.location.hash,
    query: state.router.location.query,
    allItemData: state.itemData,
    apiQueryState: state.apiQueryState,
});

export default connect(mapStateToProps)(About);
